import Modal from 'react-bootstrap/Modal'
import { faPlain, toman } from 'utilities/helper/format'

/**
 * Confirming «ثبت پرداخت» for a basket of installments.
 *
 * The shared `AddJustPayForOtherModal` cannot be used here: it posts a
 * **حق عضویت** cash-in (`type: 'cnp'`) for `item.unpaid_portion`, so on a loan
 * it would have credited the member's dues instead of repaying the loan — and
 * only ever for one amount. This one records the installments, one call each.
 *
 * The amount shown is the installments only. A recorded payment is cash handed
 * to the manager: it carries no commission, so repeating the «هزینه اشتراک»
 * from the gateway receipt above would overstate what changes hands.
 */
export default function RecordPaymentModal({
    show,
    onHide,
    count,
    amount,
    isRecording,
    onConfirm,
}: {
    show: boolean
    onHide: () => void
    count: number
    amount: number
    isRecording: boolean
    onConfirm: () => void
}) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="record-payment-title"
            centered
        >
            <div className="px-5 py-4 text-center">
                <p
                    id="record-payment-title"
                    className="text-base font-bold text-heading"
                >
                    ثبت پرداخت {faPlain.format(count)} قسط
                </p>
                <p className="mt-2 text-[15px] font-bold text-heading">
                    {toman(amount)}
                </p>
                <p className="mt-2 text-sm text-text-secondary leading-6">
                    تایید، به منزله‌ی دریافت این مبلغ از عضو و نگهداری آن نزد
                    مدیر صندوق است. برای ثبت دستی کارمزدی گرفته نمی‌شود.
                </p>

                <button
                    type="button"
                    disabled={isRecording}
                    onClick={onConfirm}
                    className="mt-4 w-full rounded-full bg-green-1 py-2.5 text-[15px] font-bold text-white active:scale-[0.99] transition-transform motion-reduce:transition-none disabled:opacity-60"
                >
                    {isRecording
                        ? 'در حال ثبت…'
                        : `تایید و ثبت ${faPlain.format(count)} قسط`}
                </button>
                <button
                    type="button"
                    disabled={isRecording}
                    onClick={onHide}
                    className="mt-1 w-full py-2 text-center text-sm text-text-secondary disabled:opacity-60"
                >
                    بازگشت
                </button>
            </div>
        </Modal>
    )
}
